import { stdSerializers } from 'browser-bunyan';
export default function serializeErr(err) {
  if (err instanceof Error && !err.stack) {
    return {
      name: err.name,
      message: err.message,
      stack: "".concat(err.name, ": ").concat(err.message)
    };
  }
  return stdSerializers.err(err);
}